import { upperFirst } from 'lodash'

import { regExp } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  const currency = options?.payload?.settings?.['billings.currency']

  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy() ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options),
        {
          props: {
            value: this.proxy,
            items: [
              {
                props: {
                  suffix: this.getTranslate(`currency.${currency}.symbol.unicode`),
                  mask: regExp.positiveNumber,
                  defaultValue: '0'
                }
              }
            ],
            dialog: true
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
